import React from 'react'

const InlineSpinner = () => {
  return (
    <div className="spinner-border text-primary" style={{ height: '19px', width: '19px' }} role="status">
      <span className="sr-only">Loading...</span>
    </div>
  )
}

export default InlineSpinner
